import React, { Component } from 'react';
import { browserHistory, Link, hashHistory } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { loginUser, fetchUser, loginWithProvider } from '../../actions/firebase_actions';
import YouTube from 'react-youtube';
import utils from '../../utils/config.js';
import Privacy from '../documents/privacy/';
import Terms from '../documents/terms/';
import License from '../documents/license/';
import Copyright from '../documents/copyright/';
import Version_History from '../version_history/'
import {updateModal} from '../../actions/modal.js';
class UserLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: '',
       width: window.innerWidth,
    };
  }


  componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  // make sure to remove the listener
  // when the component is not mounted anymore
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };


    hideModal() {
        this.setState({show: false});
    }

    showModal(content) {
      var modalContent;
      if (content == 'privacy')modalContent = <Privacy/>;
      if (content == 'version_history')modalContent = <Version_History/>;
      if (content == 'terms')modalContent = <Terms/>;
      if (content == 'license')modalContent = <License/>;
      if (content == 'copyright')modalContent = <Copyright/>;
      this.props.updateModal(true,modalContent);
    }

    _onReady(event) {
 // access to player in all event handlers via event.target
 event.target.pauseVideo();
}

    render() {
      const opts = {
      height: '240',
      width: '426',
      playerVars: { // https://developers.google.com/youtube/player_parameters
        autoplay: 1
      }
    }
      var version = utils.getVersion();
      var copyright = utils.getCopyright();
      var twitter = utils.getTwitter();
      var appName = utils.getAppName();
      var companyLink = "Ambrose Gaming";
      var twitterLink = "@TrickStrat";
      var supportEmail = "support@trickstrat.com";
      var businessEmail = "rob@trickstrat.com";
      var companyLink = "Ambrose Gaming";
      var twitterLink = "@TrickStrat";
      var supportEmail = "support@trickstrat.com";
      var businessEmail = "rob@trickstrat.com";
      const { width } = this.state;
      const isMobile = width <= 760;
      var isTouchSupported = "ontouchend" in document;
      //if (!isMobile) {
      //      if (!isTouchSupported)
      var ua = navigator.userAgent;
      if(!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua))
      {
        companyLink = <a target="_blank"  data-rel="external" className="linkText" href="http://ambrosegaming.com">Ambrose Gaming</a>
        twitterLink = <a class="twitter-follow-button" className="linkText"  data-rel="external" target="_blank" href="https://twitter.com/TrickStrat">{twitter}</a>
        supportEmail = <a class="twitter-follow-button" data-rel="external" className="linkText" href="mailto:support@trickstrat.com?Subject=Trick%20Strat%20Support">support@trickstrat.com</a>
        businessEmail = <a class="twitter-follow-button" data-rel="external" className="linkText" href="mailto:rob@trickstrat.com?Subject=Trick%20Strat%20Inquiry">rob@trickstrat.com</a>
      }
        return (
            <div>
                <form className="bodyText">
                  <span className="headerText">About</span><br/>
                    <br />
                    <p>{appName} is developed and maintained by {companyLink}.
                    <br/><br/>
                      Follow {twitterLink} on Twitter for the latest news and updates!
                    <br/><br/>
                      Questions or feedback? Email {supportEmail}.
                  <br/><br/>
                      <span className="legalText">
                      <span className="linkText" onClick={(event) => {this.showModal('terms');}}>Terms of Use</span>
                      <span> - </span>
                      <span className="linkText" onClick={(event) => {this.showModal('license');}}>End-User Agreement</span>
                      <span> - </span>
                      <span className="linkText" onClick={(event) => {this.showModal('privacy');}}>Privacy Policy</span>
                        <span> - </span>
                        <span className="linkText" onClick={(event) => {this.showModal('copyright');}}>Copyright Policy</span>
                      <br/>
                        <span className="linkText" onClick={(event) => {this.showModal('version_history');}}>{appName} {version}</span> {copyright}
                        <span> - </span>
                        Patent Pending
                      </span>
                      <br/><br/>
                        <YouTube videoId="OvSPgelsMEc" opts={opts} onReady={this._onReady} />
                    </p>
                </form>
            </div>

        );
    }

}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
      updateModal
    }, dispatch);
}

function mapStateToProps(state) {
    return { currentUser: state.currentUser };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserLogin);



// WEBPACK FOOTER //
// ./src/app/components/about/index.jsx